export const AGENT_ID = '2000001533'
//export const AGENT_ID ="2000000862"
//export const AGENT_ID ="2000001100"

export const AGENT_STATUS = {
  ACTIVE: 10,
  INACTIVE: 11,
  TERMINATED: 12,
  SUSPENDED: 13,
}

export const OTP_NOT_REQUIRED_CHANNEL = ['413892764203', '7176', '8030', '3155', '3155']

export const TRANSACTION = 'TRANSACTION'
export const VALIDATE_BENEFICIARY = 'VALIDATE_BENEFICIARY'

//TODO: Static values remove
const MIN_TRANSFER_AMOUNT = 100
const MAX_TRANSFER_AMOUNT = 50000000
const MAX_DAILY_LIMIT = 25000;

const DMT_LOADING_MESSAGE =
  'Your transaction is taking longer than usual to complete this payment. Your money is safe, and your payment should be completed within 30 minutes. Hold on, we are checking the status..'

export { DMT_LOADING_MESSAGE, MAX_TRANSFER_AMOUNT, MIN_TRANSFER_AMOUNT, MAX_DAILY_LIMIT }
